<!-- cv中文简历信息表 -->
<template>
  <div class='cn-container'>
    <div class='cv-menu'>
      <cv-menu lang='cn'></cv-menu>
    </div>
    <div class='cv-main'>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import cvMenu from './components/cv-menu'
export default {
  name: '',
  components: {
    cvMenu
  },
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
.cn-container {
  display: flex;
  .cv-menu {
    flex: 0 0 200px;
    padding-right: 20px;
    height: 40px;
  }
  .cv-main {
    flex: 1;
  }
}
</style>
